(function () {
    'use strict';

    angular.module("imApp").factory("poFinishProdWorksService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductWorks: function (parms) {
                return $ihttp.post({
                    method: 263,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
